import { omitBy, isNil } from 'lodash'

export function oauthGoogleAuthenticatorURL (config, { scope, state, refcode, roistatVisitId }) {
  if (config.oauth && config.oauth.google) {
    return buildURL(config.oauth.google, { scope, state, refcode, roistatVisitId })
  }
  return null
}

export async function oauthGoogleAuthenticator (config, { scope, state, refcode, roistatVisitId }) {
  const url = oauthGoogleAuthenticatorURL(config, { scope, state, refcode, roistatVisitId })
  if (config.oauth && config.oauth.google) {
    document.location.href = url
  }
}

export function oauthFacebookAuthenticatorURL (config, { scope, state, refcode, roistatVisitId }) {
  if (config.oauth && config.oauth.facebook) {
    return buildURL(config.oauth.facebook, { scope, state, refcode, roistatVisitId })
  }
  return null
}

export async function oauthFacebookAuthenticator (config, { scope, state, refcode, roistatVisitId }) {
  const url = oauthFacebookAuthenticatorURL(config, { scope, state, refcode, roistatVisitId })
  if (url) {
    document.location.href = url
  }
}

export function oauthAppleAuthenticatorURL (config, { scope, state, refcode, roistatVisitId }) {
  if (config.oauth && config.oauth.apple) {
    return buildURL(config.oauth.apple, { scope, state, refcode, roistatVisitId })
  }
  return null
}

export async function oauthAppleAuthenticator (config, { scope, state, refcode, roistatVisitId }) {
  const url = oauthAppleAuthenticatorURL(config, { scope, state, refcode, roistatVisitId })
  if (url) {
    document.location.href = url
  }
}

function buildURL (baseURL, params = {}) {
  const providedParams = omitBy(params, isNil)
  const qs = Object.keys(providedParams)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&')
  return qs === ''
    ? baseURL
    : `${baseURL}?${qs}`
}
